
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9m5D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b25e149e99979c$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $lO7zi = parcelRequire("lO7zi");

var $hCdov = parcelRequire("hCdov");
class $c1b25e149e99979c$export$2e2bcd8739ae039 {
    cCoord;
    center = new (0, $lO7zi.default)("O");
    tags = [];
    constructor(cCoord, tags){
        this.cCoord = cCoord;
        this.tags = tags.map((tag)=>new (0, $lO7zi.default)(tag));
        this.updateCenter();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    updateCenter = ()=>this.center.updateCoord({
            x: this.cCoord.x + 21,
            y: this.cCoord.y + 21
        });
    setAllVisible = (visible)=>[
            this.center,
            ...this.tags
        ].forEach((pTag)=>pTag.visible = visible);
    updateCoord(radians, radius) {
        const coords = (0, $hCdov.default)(this.cCoord, radians, radius + 30);
        coords.forEach((coord, cI)=>this.tags[cI].updateCoord(coord));
    }
}

});

parcelRegister("f8pkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5728371334eb545$export$2e2bcd8739ae039);

var $g4gW0 = parcelRequire("g4gW0");

var $a92Ax = parcelRequire("a92Ax");

var $eP48i = parcelRequire("eP48i");

var $erVR3 = parcelRequire("erVR3");
class $a5728371334eb545$export$2e2bcd8739ae039 {
    rootEventBus = (0, $erVR3.rootEventBus);
    EnumRootEventBus = (0, $erVR3.EnumRootEventBus);
    Angles = [];
    constructor(anglePropsArr, followCircleAnim = true){
        this.Angles = anglePropsArr.map((angleProps, aI)=>new (0, $g4gW0.default)(`a${aI + 1}`, angleProps.angleColors, angleProps.smallDistanceOffset, angleProps.addCon, angleProps.addSmallDis));
        if (followCircleAnim) {
            this.rootEventBus.on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
            this.rootEventBus.on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
        }
    }
    setAllVisible = (v)=>this.Angles.forEach((angle)=>angle.setVisible(v));
    getAngles = ()=>this.Angles;
    drawAngle(angle, p, degree, clockwise) {
        const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
        const smllDistance = Math.floor(Math.min((0, $eP48i.default)(p.curr, p.prev), (0, $eP48i.default)(p.curr, p.next)));
        angle.smallDistance = smllDistance;
        angle.draw(p.curr, startRadian, endRadian, degree, !clockwise);
        angle.x = p.curr.x;
        angle.y = p.curr.y;
        angle.rotation = 0;
    }
}

});
parcelRegister("g4gW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d65a8310461d1d$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $i30uN = parcelRequire("i30uN");

var $3f3J1 = parcelRequire("3f3J1");
class $b0d65a8310461d1d$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    AngleValue;
    arc;
    arcStroke;
    tag;
    startRadian;
    endRadian;
    degree;
    fillColor;
    smallDistance = 100;
    smallDistanceOffset = 0;
    addSmallDis = true;
    constructor(tag, angleColor, smallDistanceOffset = 0, addCon = false, addSmallDis = true){
        super();
        this.tag = tag;
        this.fillColor = angleColor.color;
        this.smallDistanceOffset = smallDistanceOffset;
        this.addSmallDis = addSmallDis;
        this.AngleValue = new (0, $i30uN.default)({
            x: -100,
            y: -100
        }, angleColor.textColor);
        this.addArc();
        !addCon && this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    addArc() {
        this.arc = new $iuB9z.Graphics();
        this.addChild(this.arc);
        this.arcStroke = new $iuB9z.Graphics();
        this.addChild(this.arcStroke);
    }
    setVisible(status) {
        this.visible = status;
        this.AngleValue.visible = status;
    }
    draw(cCoord, startRadian, endRadian, degree, cClockwise) {
        const sD = this.smallDistance;
        const radian = sD <= 76 + this.smallDistanceOffset && this.addSmallDis ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
        this.degree = degree;
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        if (degree == 90) {
            this.arcStroke.clear();
            (0, $3f3J1.drawSquare)(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
        } else {
            (0, $3f3J1.drawArc)(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
            (0, $3f3J1.drawArc)(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false);
        }
        const initialAngle = cClockwise ? endRadian : startRadian;
        this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
    }
}

});
parcelRegister("i30uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6935df93860f2c37$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $eymUv = parcelRequire("eymUv");
class $6935df93860f2c37$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(coord, color){
        super();
        this.text = "60\xb0";
        this.style.fill = color;
        this.style.fontSize = 34;
        this.style.fontWeight = "800";
        this.anchor.set(.5);
        this.setAngleValue(coord, 0, 0, 38);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Top.addChild(this);
    setValue = (value)=>this.text = `${value}\xb0`;
    setAngleValue(cCoord, initialAngle, degree, radian) {
        const angle = initialAngle + (0, $eymUv.default)(degree / 2);
        const coord = {
            x: Math.cos(angle) * radian * 1.7 + cCoord.x,
            y: Math.sin(angle) * radian * 1.7 + cCoord.y
        };
        this.setValue(degree);
        this.style.fontSize = radian;
        this.x = coord.x;
        this.y = coord.y;
    }
}

});
parcelRegister("eymUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afd35e271dc067b$export$2e2bcd8739ae039);
function $0afd35e271dc067b$export$2e2bcd8739ae039(degree) {
    return degree * (Math.PI / 180);
}

});


parcelRegister("3f3J1", function(module, exports) {

$parcel$export(module.exports, "drawArc", () => $827e00f616855d7e$export$bf8a3f9983094125);
$parcel$export(module.exports, "drawSquare", () => $827e00f616855d7e$export$9340b6a85ea854b9);
function $827e00f616855d7e$export$bf8a3f9983094125(arc, r, sRadian, eRadian, w, color, cClockwise, isStroke) {
    arc.clear();
    if (!isStroke) arc.arc(0, 0, r, sRadian, eRadian, cClockwise).stroke({
        width: w,
        color: color
    });
    else arc.moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r).lineTo(0, 0).arc(0, 0, r, sRadian, eRadian, cClockwise).moveTo(0, 0).lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r).stroke({
        width: w,
        color: color
    });
    arc.rotation = 0;
}
function $827e00f616855d7e$export$9340b6a85ea854b9(square, dim, startRadian, endRadian, color, cClockwise) {
    square.clear();
    square.rect(0, 0, dim, dim).fill(color).stroke({
        color: 0x000000,
        width: 3
    });
    square.rotation = !cClockwise ? startRadian : endRadian;
}

});


parcelRegister("a92Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2e4f2e6d187ae4$export$2e2bcd8739ae039);

var $2h5MD = parcelRequire("2h5MD");
function $1f2e4f2e6d187ae4$export$2e2bcd8739ae039(cCoord, coordStart, coordEnd) {
    const startRadian = (0, $2h5MD.default)(cCoord, coordStart);
    const endRadian = (0, $2h5MD.default)(cCoord, coordEnd);
    return {
        startRadian: startRadian,
        endRadian: endRadian
    };
}

});


parcelRegister("eitLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $295d8ae516c805d1$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");

var $gcphA = parcelRequire("gcphA");
class $295d8ae516c805d1$export$2e2bcd8739ae039 {
    CheckboxRenderer;
    isChecked = false;
    checkBoxLabel;
    handleFunc;
    constructor(coord, label, color, useCustomLayer = false, handleFunc = (label, v)=>{}){
        this.CheckboxRenderer = new (0, $gcphA.default)(color, label, useCustomLayer);
        Object.assign(this.CheckboxRenderer, coord);
        this.handleFunc = handleFunc;
        this.addInteractivity();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    addToCon = (con)=>con.addChild(this.CheckboxRenderer);
    setScale = (v)=>this.CheckboxRenderer.con.scale.set(v);
    setVisible = (v)=>this.CheckboxRenderer.visible = v;
    addInteractivity() {
        const handleUpFunc = ()=>this.handleCheckbox();
        (0, $16Wgx.default)(this.CheckboxRenderer, {
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    handleCheckbox() {
        this.isChecked = !this.isChecked;
        this.handleFunc(this.checkBoxLabel, this.isChecked);
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
    getIsChecked() {
        return {
            label: this.checkBoxLabel,
            isChecked: this.isChecked
        };
    }
    setChecked(v) {
        this.isChecked = v;
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
}

});
parcelRegister("gcphA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f182ab57cf75ac$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $c6f182ab57cf75ac$export$2e2bcd8739ae039 extends $iuB9z.Container {
    color;
    checkboxLabel;
    Layers;
    con;
    checkedSquare;
    defaultColor;
    constructor(color, checkboxLabel, useCustomLayer = false){
        super(), this.color = color, this.checkboxLabel = checkboxLabel, this.Layers = (0, $9ec1t.default).getInstance(), this.con = this.addChild(new $iuB9z.Container()), this.checkedSquare = this.con.addChild(new $iuB9z.Graphics()), this.defaultColor = 0xFFFFFF, this.addToLayer = ()=>this.Layers.UI.addChild(this);
        this.drawCheckbox(false);
        this.addLabel();
        !useCustomLayer && this.addToLayer();
    }
    addToLayer;
    drawCheckbox(isColored) {
        const fillColor = isColored ? this.color : this.defaultColor;
        this.checkedSquare.clear().roundRect(0, -20, 40, 40, 10).fill(fillColor).stroke({
            width: 2,
            color: 0x000000
        });
    }
    addLabel() {
        const text = new $iuB9z.Text({
            text: this.checkboxLabel
        });
        text.style.fontSize = 36;
        text.style.fill = this.color;
        text.anchor.set(0, .5);
        text.x = 50;
        text.y = 0;
        this.con.addChild(text);
    }
}

});


parcelRegister("jISXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66faaaf67ef5cb50$export$2e2bcd8739ae039);
function $66faaaf67ef5cb50$export$2e2bcd8739ae039(dim, CENTER_OF_CIRCLE) {
    if (dim.WIDTH > dim.HEIGHT) return CENTER_OF_CIRCLE;
    return {
        x: dim.WIDTH / 2,
        y: dim.HEIGHT / 2
    };
}

});

parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $75RpY = parcelRequire("75RpY");

var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");

var $fGH3X = parcelRequire("fGH3X");

var $iiVV4 = parcelRequire("iiVV4");

var $5ehzb = parcelRequire("5ehzb");

var $iuB9z = parcelRequire("iuB9z");
var $824b821ead0f7201$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["moveCircumPoint"] = "MOVE_CIRCUMFERENCE_POINT";
    EnumEventBus["moveChordA"] = "MOVE_CHORD_A";
    EnumEventBus["moveChordB"] = "MOVE_CHORD_B";
    EnumEventBus["setPointChecklist"] = "SET_POINT_CHECK_LIST";
    return EnumEventBus;
}({});
const $824b821ead0f7201$export$f6644f0f2c90144b = new (0, $iuB9z.EventEmitter)();


const $ca5b6c2a07f443e8$export$7a003cdef7722780 = [
    0xFC99C4,
    0xF94F6F
];
const $ca5b6c2a07f443e8$export$c7609d9da8d80867 = {
    x: 600,
    y: 310
};
const $ca5b6c2a07f443e8$export$ca8f2c484d507a5d = 200;
const $ca5b6c2a07f443e8$export$71b7ee2b1d39589f = 130;
const $ca5b6c2a07f443e8$export$95c476c8e1b0007 = [
    Math.PI / 16,
    Math.PI / 4 * 3
];
const $ca5b6c2a07f443e8$export$bdea539c223eec51 = [
    0x000000,
    0x000000,
    0x000000
];
const $ca5b6c2a07f443e8$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $ca5b6c2a07f443e8$export$186dbbe504e85fe1 = [
    {
        x: 70,
        y: 800
    },
    {
        x: 440,
        y: 800
    },
    {
        x: 810,
        y: 800
    }
];
const $ca5b6c2a07f443e8$export$75f2cc8245aafe09 = [
    {
        x: -260,
        y: 400
    },
    {
        x: -260,
        y: 600
    },
    {
        x: 60,
        y: 400
    }
];
const $ca5b6c2a07f443e8$export$2e51dc0dfab2d766 = "circle-theorem-9";



var $hCdov = parcelRequire("hCdov");
function $3a05c08356e2c8eb$export$8eaa7687b309599b(cCoord, circleRadius, pointRadian, intersecRadius) {
    if (!cCoord || !circleRadius || !pointRadian || !intersecRadius) return Array(3).fill({
        x: 0,
        y: 0
    });
    const intersecCoord = (0, $hCdov.default)(cCoord, [
        pointRadian
    ], intersecRadius)[0];
    const sideLength = Math.sqrt(Math.pow(circleRadius, 2) - Math.pow(intersecRadius, 2));
    const getCoord = (radian)=>({
            x: intersecCoord.x + Math.cos(radian) * sideLength,
            y: intersecCoord.y + Math.sin(radian) * sideLength
        });
    return [
        getCoord(pointRadian + Math.PI / 2),
        intersecCoord,
        getCoord(pointRadian - Math.PI / 2)
    ];
}



var $erVR3 = parcelRequire("erVR3");
class $406c7e32dc7f5336$export$2e2bcd8739ae039 extends (0, $5ehzb.default) {
    intersecLA = (0, $ca5b6c2a07f443e8$export$71b7ee2b1d39589f);
    intersecLB = (0, $ca5b6c2a07f443e8$export$71b7ee2b1d39589f);
    chordAPoints;
    chordBPoints;
    pointCheckList = [];
    tags = [];
    constructor(cCoord){
        super(cCoord, (0, $ca5b6c2a07f443e8$export$ca8f2c484d507a5d), (0, $ca5b6c2a07f443e8$export$95c476c8e1b0007));
        this.setCoord();
        this.draw();
        this.chordAPoints = (0, $3a05c08356e2c8eb$export$8eaa7687b309599b)(cCoord, (0, $ca5b6c2a07f443e8$export$ca8f2c484d507a5d), this.pointRadians[0], this.intersecLA);
        this.chordBPoints = (0, $3a05c08356e2c8eb$export$8eaa7687b309599b)(cCoord, (0, $ca5b6c2a07f443e8$export$ca8f2c484d507a5d), this.pointRadians[1], this.intersecLB);
        this.tags = this.getRedPoints().map((p)=>p.tag);
        (0, $824b821ead0f7201$export$f6644f0f2c90144b).on((0, $824b821ead0f7201$export$cb883390c27ec6dd).setPointChecklist, (l)=>this.pointCheckList = l);
        (0, $824b821ead0f7201$export$f6644f0f2c90144b).on((0, $824b821ead0f7201$export$cb883390c27ec6dd).moveCircumPoint, (v)=>this.handleMoveCircumPoints(v));
        (0, $824b821ead0f7201$export$f6644f0f2c90144b).on((0, $824b821ead0f7201$export$cb883390c27ec6dd).moveChordA, (v)=>this.handleMoveChordA(v));
        (0, $824b821ead0f7201$export$f6644f0f2c90144b).on((0, $824b821ead0f7201$export$cb883390c27ec6dd).moveChordB, (v)=>this.handleMoveChordB(v));
        this.rootEventBus.on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.resetChordsPoints(true));
        this.rootEventBus.on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.resetChordsPoints(false));
    }
    getChordsPoints = ()=>[
            this.chordAPoints,
            this.chordBPoints
        ];
    resetChordsPoints = (started)=>{
        const rads = started ? this.getInitialRadians() : this.pointRadiansBeforeAnim;
        this.chordAPoints = (0, $3a05c08356e2c8eb$export$8eaa7687b309599b)(this.cCoord, (0, $ca5b6c2a07f443e8$export$ca8f2c484d507a5d), rads[0], this.intersecLA);
        this.chordBPoints = (0, $3a05c08356e2c8eb$export$8eaa7687b309599b)(this.cCoord, (0, $ca5b6c2a07f443e8$export$ca8f2c484d507a5d), rads[1], this.intersecLB);
        if (!started) this.setCoord();
    };
    setRadian(pointInfoArr, isSlider) {
        pointInfoArr.forEach((pointInfo)=>{
            if (pointInfo.pTag == this.tags[0]) this.chordAPoints = (0, $3a05c08356e2c8eb$export$8eaa7687b309599b)(this.cCoord, (0, $ca5b6c2a07f443e8$export$ca8f2c484d507a5d), pointInfo.radian, this.intersecLA);
            else this.chordBPoints = (0, $3a05c08356e2c8eb$export$8eaa7687b309599b)(this.cCoord, (0, $ca5b6c2a07f443e8$export$ca8f2c484d507a5d), pointInfo.radian, this.intersecLB);
        });
        this._setRadian(pointInfoArr, isSlider);
    }
    handleMoveCircumPoints(v) {
        const points = this.getRedPoints();
        const radians = this.getRefRadians();
        const generateOffsetRadian = (v)=>Math.PI / 300 * v;
        const pointInfoArr = this.pointCheckList.map((e, eI)=>this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0)).map((r, rI)=>({
                pTag: points[rI].tag,
                radian: r
            })).filter((pointInfo, pII)=>pointInfo.radian != radians[pII]);
        this.setRadian(pointInfoArr, true);
    }
    handleMoveChordA(v) {
        this.intersecLA = Math.floor(v * .45 + (0, $ca5b6c2a07f443e8$export$71b7ee2b1d39589f));
        const pointInfoArr = this.getCurrRedPointInfo(0);
        this.setRadian(pointInfoArr, true);
    }
    handleMoveChordB(v) {
        this.intersecLB = Math.floor(v * .45 + (0, $ca5b6c2a07f443e8$export$71b7ee2b1d39589f));
        const pointInfoArr = this.getCurrRedPointInfo(1);
        this.setRadian(pointInfoArr, true);
    }
    getCurrRedPointInfo(index) {
        const point = this.RedPointsArr[index];
        const radian = this.pointRadians[index];
        return [
            {
                pTag: point.tag,
                radian: radian
            }
        ];
    }
}



var $9m5D8 = parcelRequire("9m5D8");
class $c54541b877b77ead$export$2e2bcd8739ae039 extends (0, $9m5D8.default) {
    constructor(cCoord){
        super(cCoord, [
            "A",
            "B"
        ]);
    }
}



var $d0yDD = parcelRequire("d0yDD");

var $erVR3 = parcelRequire("erVR3");
class $2e2f239987868ccb$export$2e2bcd8739ae039 {
    cCoord;
    lines = [
        new (0, $d0yDD.default)({
            color: 0x21D4FE,
            isEqualSymbol: true
        }),
        new (0, $d0yDD.default)({
            color: 0x21D4FE,
            isEqualSymbol: true
        }),
        new (0, $d0yDD.default)(),
        new (0, $d0yDD.default)({
            color: 0xb06efe,
            isEqualSymbol: true
        }),
        new (0, $d0yDD.default)({
            color: 0xb06efe,
            isEqualSymbol: true
        }),
        new (0, $d0yDD.default)()
    ];
    constructor(cCoord){
        this.cCoord = cCoord;
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.clearAll());
    }
    clearAll = ()=>this.lines.forEach((l)=>{
            l.setVisibleOfEqualSymbol(false);
            l.clear();
        });
    draw(points, chordsPoints) {
        const chordA = chordsPoints[0];
        const chordB = chordsPoints[1];
        this.lines[0].draw(chordA[0], chordA[1]);
        this.lines[1].draw(chordA[1], chordA[2]);
        this.lines[2].draw(this.cCoord, points[0]);
        this.lines[3].draw(chordB[0], chordB[1]);
        this.lines[4].draw(chordB[1], chordB[2]);
        this.lines[5].draw(this.cCoord, points[1]);
    }
}



var $f8pkD = parcelRequire("f8pkD");

const $5f4f3bc19c42855e$var$pAC = (0, $ca5b6c2a07f443e8$export$7a003cdef7722780);
class $5f4f3bc19c42855e$export$2e2bcd8739ae039 extends (0, $f8pkD.default) {
    cCoord;
    constructor(cCoord){
        const anglePropsArr = Array(2).fill(null).map((_, i)=>({
                angleColors: {
                    color: $5f4f3bc19c42855e$var$pAC[0],
                    textColor: $5f4f3bc19c42855e$var$pAC[1]
                },
                smallDistanceOffset: 20,
                addSmallDis: false
            }));
        super(anglePropsArr);
        this.cCoord = cCoord;
    }
    draw(chordsPoints, clockwise = true) {
        chordsPoints.forEach((chordPoints, cPI)=>{
            const Points = {
                curr: chordPoints[1],
                prev: this.cCoord,
                next: chordPoints[0]
            };
            const degree = 90;
            this.drawAngle(this.Angles[cPI], Points, degree, clockwise);
        });
    }
}




var $b2sIL = parcelRequire("b2sIL");

var $eitLW = parcelRequire("eitLW");

const $65d1f216ad1adc7e$var$SliderGen = [
    {
        head: "move chord A",
        colors: {
            bgColor: 0x21D4FE,
            barColor: 0x000000,
            buttonColor: 0x21D4FE
        },
        keepCurrSlider: true,
        onUpdate: (v)=>(0, $824b821ead0f7201$export$f6644f0f2c90144b).emit((0, $824b821ead0f7201$export$cb883390c27ec6dd).moveChordA, v - 100)
    },
    {
        head: "move chord B",
        colors: {
            bgColor: 0xB5A1FF,
            barColor: 0x000000,
            buttonColor: 0xB5A1FF
        },
        keepCurrSlider: true,
        onUpdate: (v)=>(0, $824b821ead0f7201$export$f6644f0f2c90144b).emit((0, $824b821ead0f7201$export$cb883390c27ec6dd).moveChordB, v - 100)
    },
    {
        head: "rotate chords",
        subHead: "(select which one to use)",
        colors: {
            bgColor: 0xBFBFBF,
            barColor: 0x000000,
            buttonColor: 0x000000
        },
        onUpdate: (v)=>(0, $824b821ead0f7201$export$f6644f0f2c90144b).emit((0, $824b821ead0f7201$export$cb883390c27ec6dd).moveCircumPoint, v - 100)
    }
];
const $65d1f216ad1adc7e$var$pointName = [
    "Chord A",
    "Chord B"
];
class $65d1f216ad1adc7e$export$2e2bcd8739ae039 extends (0, $b2sIL.default) {
    pointCheckboxes = [];
    pointChecklist = Array(2).fill(false);
    constructor(){
        super($65d1f216ad1adc7e$var$SliderGen, (0, $ca5b6c2a07f443e8$export$186dbbe504e85fe1), (0, $ca5b6c2a07f443e8$export$75f2cc8245aafe09));
        this.addCheckBoxes();
    }
    handleCheckbox(index, v) {
        this.pointChecklist[index] = v;
        (0, $824b821ead0f7201$export$f6644f0f2c90144b).emit((0, $824b821ead0f7201$export$cb883390c27ec6dd).setPointChecklist, this.pointChecklist);
    }
    addCheckBoxes() {
        const coords = $65d1f216ad1adc7e$var$getPointCheckboxCoords(this.dim);
        this.pointCheckboxes = Array(2).fill((0, $ca5b6c2a07f443e8$export$7a003cdef7722780)[0]).map((e, eI)=>new (0, $eitLW.default)(coords[eI], $65d1f216ad1adc7e$var$pointName[eI], e, false, (label, v)=>this.handleCheckbox(eI, v)));
        this.dim.WIDTH < this.dim.HEIGHT && this.pointCheckboxes.forEach((cbox)=>cbox.setScale(.8));
    }
}
function $65d1f216ad1adc7e$var$getPointCheckboxCoords(dim) {
    const coordHorizontal = [
        {
            x: 1135,
            y: 775
        },
        {
            x: 1135,
            y: 825
        }
    ];
    const getCoordHorizontal = (eI)=>coordHorizontal[eI];
    const getCoordVertical = (eI)=>({
            x: dim.WIDTH / 2 + 35 + (eI > 1 ? 150 : 0),
            y: dim.HEIGHT / 2 + 520 + (eI % 2 == 1 ? 40 : 0)
        });
    const coords = Array(2).fill(null).map((e, eI)=>dim.WIDTH > dim.HEIGHT ? getCoordHorizontal(eI) : getCoordVertical(eI == 1 ? eI + 1 : eI));
    return coords;
}




var $jISXQ = parcelRequire("jISXQ");

var $3DpJv = parcelRequire("3DpJv");

var $erVR3 = parcelRequire("erVR3");

var $iD90R = parcelRequire("iD90R");


var $darcK = parcelRequire("darcK");
async function $d5b3dfcba911f0ec$export$2721aded6352b5ea(context, onComp) {
    const { circle: circle, LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager, cCoord: cCoord } = context;
    [
        AngleManager
    ].forEach((manager)=>manager.setAllVisible(false));
    const centerPoint = PointManager.getPoints()[0];
    const centerPointCoord = PointManager.getPointsCoord()[0];
    const pointsCoord = PointManager.getRedPointsCoord();
    const chordsPoints = PointManager.getChordsPoints();
    const chordAPoints = chordsPoints[0];
    const chordBPoints = chordsPoints[1];
    const RedPoints = PointManager.getRedPoints();
    const initialRadian = PointManager.getInitialRadians();
    const angles = AngleManager.getAngles();
    AngleManager.draw(chordsPoints);
    circle.setRadians([
        (0, $ca5b6c2a07f443e8$export$95c476c8e1b0007)[0],
        (0, $ca5b6c2a07f443e8$export$95c476c8e1b0007)[0]
    ]);
    (0, $iD90R.drawPointsAnim)([
        centerPoint
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $ca5b6c2a07f443e8$export$95c476c8e1b0007)[0] + Math.PI * 2, 0, true, cCoord);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[2], centerPointCoord, pointsCoord[0]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[0], chordAPoints[0], chordAPoints[2]);
    LineManager.lines[0].draw(chordAPoints[0], chordAPoints[1]);
    LineManager.lines[1].draw(chordAPoints[1], chordAPoints[2]);
    await (0, $iD90R.addCustomDelay)(500);
    LineManager.lines[0].setVisibleOfEqualSymbol(true);
    LineManager.lines[1].setVisibleOfEqualSymbol(true);
    await (0, $iD90R.addCustomDelay)(200);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[5], centerPointCoord, pointsCoord[1]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[3], chordBPoints[0], chordBPoints[2]);
    LineManager.lines[3].draw(chordBPoints[0], chordBPoints[1]);
    LineManager.lines[4].draw(chordBPoints[1], chordBPoints[2]);
    await (0, $iD90R.addCustomDelay)(500);
    LineManager.lines[3].setVisibleOfEqualSymbol(true);
    LineManager.lines[4].setVisibleOfEqualSymbol(true);
    await (0, $iD90R.addCustomDelay)(200);
    await (0, $iD90R.drawAngleAnim)(angles[0], "x");
    await (0, $iD90R.drawAngleAnim)(angles[1], "x");
    await (0, $iD90R.rotateCircleAnim)((v)=>PointManager.setRadian(Array(2).fill("").map((_, rI)=>({
                pTag: RedPoints[rI].tag,
                radian: (0, $darcK.normalizeRadian)(initialRadian[rI] + v)
            }))));
    await (0, $iD90R.drawPointsAnim)(RedPoints);
    onComp();
}



var $e8wW1 = parcelRequire("e8wW1");

class $031bbda24ad7c272$export$2e2bcd8739ae039 {
    PointManager;
    AngleManager;
    LineManager;
    circle;
    cCoord;
    constructor(PointManager, AngleManager, LineManager, circle, cCoord){
        this.PointManager = PointManager;
        this.AngleManager = AngleManager;
        this.LineManager = LineManager;
        this.circle = circle;
        this.cCoord = cCoord;
        this.addCircAnimBut = ()=>new (0, $e8wW1.default)((0, $ca5b6c2a07f443e8$export$840ec2322406bfdd), ()=>this.runAnimations());
        this.addCircAnimBut();
    }
    addCircAnimBut;
    runAnimations() {
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).startedCircleAnim);
        const context = {
            PointManager: this.PointManager,
            AngleManager: this.AngleManager,
            LineManager: this.LineManager,
            circle: this.circle,
            cCoord: this.cCoord
        };
        (0, $d5b3dfcba911f0ec$export$2721aded6352b5ea)(context, ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).completedCircleAnim);
        });
    }
}


class $038b867bef6e4028$export$2e2bcd8739ae039 {
    Game = (0, $75RpY.default).getInstance();
    circleRadius = (0, $ca5b6c2a07f443e8$export$ca8f2c484d507a5d);
    cCoord = (0, $jISXQ.default)(this.Game.getDim(), (0, $ca5b6c2a07f443e8$export$c7609d9da8d80867));
    PointManager = new (0, $406c7e32dc7f5336$export$2e2bcd8739ae039)(this.cCoord);
    PointTagManager = new (0, $c54541b877b77ead$export$2e2bcd8739ae039)(this.cCoord);
    LineManager = new (0, $2e2f239987868ccb$export$2e2bcd8739ae039)(this.cCoord);
    AngleManager = new (0, $5f4f3bc19c42855e$export$2e2bcd8739ae039)(this.cCoord);
    circle = new (0, $iiVV4.default)(this.cCoord, (0, $ca5b6c2a07f443e8$export$95c476c8e1b0007), (0, $ca5b6c2a07f443e8$export$bdea539c223eec51));
    guideText = new (0, $3DpJv.default)(undefined, true);
    InfoSlider = new (0, $fGH3X.default)((0, $ca5b6c2a07f443e8$export$840ec2322406bfdd));
    SliderManager = new (0, $65d1f216ad1adc7e$export$2e2bcd8739ae039)();
    CircleAnimationManager;
    constructor(){
        this.CircleAnimationManager = new (0, $031bbda24ad7c272$export$2e2bcd8739ae039)(this.PointManager, this.AngleManager, this.LineManager, this.circle, this.cCoord);
        this.drawElements();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).drawElements, ()=>this.drawElements());
    }
    drawElements() {
        const radians = this.PointManager.getRadians();
        const redPointsCoord = this.PointManager.getRedPointsCoord();
        const chordsPoints = this.PointManager.getChordsPoints();
        this.circle.draw({
            radians: radians,
            radius: this.circleRadius
        });
        this.PointTagManager.updateCoord(radians, this.circleRadius);
        this.AngleManager.draw(chordsPoints);
        this.LineManager.draw(redPointsCoord, chordsPoints);
    }
}



const $34aa09950d922576$var$canvas = document.querySelector("#canvas");
if ($34aa09950d922576$var$canvas) window.context = new (0, $75RpY.default)($34aa09950d922576$var$canvas, (0, $ca5b6c2a07f443e8$export$2e51dc0dfab2d766), ()=>new (0, $038b867bef6e4028$export$2e2bcd8739ae039)());
else console.error("Canvas is not found");


//# sourceMappingURL=index.76d9ff63.js.map
